export default {"src":"/_next/static/media/logo.af67a8ee.svg","height":131,"width":399,"blurWidth":0,"blurHeight":0};